'use client';

import { WebAPISubsidiesPage } from '@/globals/webApiTypes/pages/WebAPISubsidiesPage';
import { useSelectedFilters } from '@/sections/filter/useSelectedFilters';
import { filterSubsidyResults } from './filterSubsidyResults';

export const SubsidyOverlayTotalResults = ({
	results,
	filters,
}: {
	results: WebAPISubsidiesPage['results'];
	filters: WebAPISubsidiesPage['filters'];
}) => {
	const [selectedFilters] = useSelectedFilters();
	const filteredResultsAmount = filterSubsidyResults(
		results,
		selectedFilters,
		filters,
	).length;

	return <>{`(${filteredResultsAmount})`}</>;
};
